const createAction = (type,content) => {
    return {
        type,
        content
    }
}
export default createAction